module.exports = __webpack_public_path__ + "img/bg_6.50c7c3fe.png";